import React from 'react';
import './AdPage.css';

const AdPage3 = () => {
  return (
    <div className="ad-page-container">
      <h1>Page 3</h1>
      <p>This is the third page with an ad banner.</p>
      
      <div className="ad-banner">
        <iframe 
          border="0" 
          src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
          style={{width:'300px', height:'250px'}} 
          frameBorder="0" 
          scrolling="no" 
          title="Trip.com Banner Advertisement"
        ></iframe>
      </div>
      
      <p>Additional content for Page 3 would go here.</p>
    </div>
  );
};

export default AdPage3;